// URL: http://qrious.com/breaky/
(function(window, document, exportName, undefined){
  var fnIndex = 0;
  // object that assigns each function to breakpoint and on/offs
  var fnSwitch = {};
  // object of all functions and active state
  var fnList = {};
  // All possible breakpoints ex, ["mobile", "tablet", "desktop"]
  var breakpoints = [];

    function setSwitch() {
      var onItems = fnSwitch[breaky.value].on;
      var onItemsLength = onItems.length;
      var offItems = fnSwitch[breaky.value].off;
      var offItemsLength = offItems.length;

      for ( var i = 0; i < onItemsLength; i++ ) {
        if(!fnList[onItems[i]].active) {
          fnList[onItems[i]].fn();
          fnList[onItems[i]].active = true;
        }
      }
      for ( var i = 0; i < offItemsLength; i++ ) {
        fnList[offItems[i]].active = false;
      }
    }

     function readValue( el, pseudo ) {
      return window.getComputedStyle(
          document.querySelector(el), ':' + pseudo
        ).getPropertyValue( 'content' ).replace( /\"/g, '' ).replace( /\'/g, '' );
    }
    // Add function to {fnList}
    function appendFunction( fn ) {
      fnIndex++;
      fnList[fnIndex] = {};
      fnList[fnIndex]["fn"] = fn;
      fnList[fnIndex]["active"] = false;
    }

    function indexOf (collection, value) {
        // check if array protype exists if not use our own
        if (Array.prototype.indexOf) {
            return collection.indexOf( value );
        }
        for (var i = 0, l = collection.length; i < l; i++) {
            if(value === collection[i]) {
                return i;
            }
        }
    }
    // adds function to {fnSwitch}
    function connectFunction( view1, direction, view2 ) {
      // get index of view 1 and view 2 relative to the breakpoints array
      var viewIndex1 = indexOf(breakpoints, view1);
      var viewIndex2 = indexOf(breakpoints, view2);


      for( var i = 0; i < breakpoints.length; i++ ) {
          if( i == viewIndex1 && direction == "at"
          || i <= viewIndex1 && direction == "below"
          || i >= viewIndex1 && direction == "above"
          || viewIndex1 <= i && i <= viewIndex2 &&  direction == "between" ) {
            fnSwitch[breakpoints[i]].on.push( fnIndex );
          } else {
            fnSwitch[breakpoints[i]].off.push( fnIndex );
          }
      }
      setSwitch();
    }
    // Populates the object {fnSwitch} which will contain
    // all functions that should be called at certain breakpoints
    // by setting on and off arrays
    function createFnSwitch() {
      breakpointsLength = breakpoints.length;

      for(var i = 0; i < breakpointsLength; i++ ) {
        fnSwitch[breakpoints[i]] = {};
        fnSwitch[breakpoints[i]].on = [];
        fnSwitch[breakpoints[i]].off = [];
      }
    }
    function connectAndAppendFn( fn, view1, direction, view2 ) {
      // adds function to fnList
      appendFunction( fn );

      // add function to
      connectFunction( view1, direction, view2 );
    }

    // Define breaky
    breaky = {
      below: function( view, fn ) {
        connectAndAppendFn( fn, view, "below" );
      },
      above: function( view, fn ) {
        connectAndAppendFn( fn, view, "above" );
      },
      between: function( view1, view2, fn ) {
        connectAndAppendFn( fn, view1, "between", view2 );
      },
      at : function( view, fn ) {
        connectAndAppendFn( fn, view, "at" );
      },
      initIE8 : function(bp, value) {
          if(!window.getComputedStyle) {
            breakpoints = bp;
            createFnSwitch();
            breaky.value = value;
          }
      },
      init : function() {
        // get all possible breakpoints
        breakpoints = readValue( "html", "before" ).split( "," );

        // populate the object fnSwitch with on/off arrays
        createFnSwitch();

        // get the current breakpoint value
        breaky.value = readValue( "body", "before" );

        window.onresize = function () {
          if(breaky.value !== readValue( "body", "before" )) {
            breaky.value = readValue( "body", "before" );
            setSwitch();
          }
        }
      }
    }
    if(document["body"]) {
      if(window.getComputedStyle) {
        breaky.init();
      }
    } else  {
      if(typeof jQuery === 'function') {
        jQuery(function(){
          if(window.getComputedStyle) {
            breaky.init();
          }
        });
      } else {
        document.addEventListener("DOMContentLoaded", function(event) {
          if(window.getComputedStyle) {
            breaky.init();
          }
        });
      }
    }
    var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {}));
    freeGlobal.breaky = breaky;
    if (typeof define === 'function' && define.amd) {
        define(function() {
            return breaky;
        });
    } else if (typeof module != 'undefined' && module.exports) {
        module.exports = breaky;
    } else {
        window[exportName] = breaky;
    }
})(window, document, 'breaky');

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-setclasses !*/
 !function(e,n,A){function o(e,n){return typeof e===n}function t(){var e,n,A,t,a,i,l;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(A=0;A<n.options.aliases.length;A++)e.push(n.options.aliases[A].toLowerCase());for(t=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],l=i.split("."),1===l.length?Modernizr[l[0]]=t:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=t),s.push((t?"":"no-")+l.join("-"))}}function a(e){var n=u.className,A=Modernizr._config.classPrefix||"";if(c&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+A+"no-js(\\s|$)");n=n.replace(o,"$1"+A+"js$2")}Modernizr._config.enableClasses&&(n+=" "+A+e.join(" "+A),c?u.className.baseVal=n:u.className=n)}function i(e,n){if("object"==typeof e)for(var A in e)f(e,A)&&i(A,e[A]);else{e=e.toLowerCase();var o=e.split("."),t=Modernizr[o[0]];if(2==o.length&&(t=t[o[1]]),"undefined"!=typeof t)return Modernizr;n="function"==typeof n?n():n,1==o.length?Modernizr[o[0]]=n:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=n),a([(n&&0!=n?"":"no-")+o.join("-")]),Modernizr._trigger(e,n)}return Modernizr}var s=[],r=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var A=this;setTimeout(function(){n(A[e])},0)},addTest:function(e,n,A){r.push({name:e,fn:n,options:A})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var f,u=n.documentElement,c="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;f=o(e,"undefined")||o(e.call,"undefined")?function(e,n){return n in e&&o(e.constructor.prototype[n],"undefined")}:function(n,A){return e.call(n,A)}}(),l._l={},l.on=function(e,n){this._l[e]||(this._l[e]=[]),this._l[e].push(n),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},l._trigger=function(e,n){if(this._l[e]){var A=this._l[e];setTimeout(function(){var e,o;for(e=0;e<A.length;e++)(o=A[e])(n)},0),delete this._l[e]}},Modernizr._q.push(function(){l.addTest=i}),Modernizr.addAsyncTest(function(){function e(e,n,A){function o(n){var o=n&&"load"===n.type?1==t.width:!1,a="webp"===e;i(e,a&&o?new Boolean(o):o),A&&A(n)}var t=new Image;t.onerror=o,t.onload=o,t.src=n}var n=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],A=n.shift();e(A.name,A.uri,function(A){if(A&&"load"===A.type)for(var o=0;o<n.length;o++)e(n[o].name,n[o].uri)})}),t(),a(s),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);

(function($) {
if($('.js-contacts-bg').length) {
  $('.js-contacts-bg').slick({
    arrows: false,
    dots: false,
    fade: true,
    autoplay: false
  });
}
$('#town-2, #town-3').css('opacity', .3);
$('#town-1').hover(function() {
  $('.js-contacts-bg').slick('slickGoTo', 0);
  $(this).css('opacity', 1);
  $('#town-2').css('opacity', .3);
  $('#town-3').css('opacity', .3);
});
$('#town-2').hover(function() {
  $('.js-contacts-bg').slick('slickGoTo', 1);
  $(this).css('opacity', 1);
  $('#town-1').css('opacity', .3);
  $('#town-3').css('opacity', .3);
});
$('#town-3').hover(function() {
  $('.js-contacts-bg').slick('slickGoTo', 2);
  $(this).css('opacity', 1);
  $('#town-1').css('opacity', .3);
  $('#town-2').css('opacity', .3);
});

if($('.js-header').length) {
  var headerElement = document.querySelector(".js-header");
  if(Headroom.cutsTheMustard) {
    var hr = new Headroom(headerElement);
    hr.init();
  }
}
$('.js-header-nav-opener').click(function(){
  $(this).toggleClass('is-open');
  $('body').toggleClass('is-nav-open');
  $('.js-header-nav').toggleClass('is-open');
});

if($('.js-intro-bg').length) {
  $('.js-intro-bg').slick({
    arrows: false,
    dots: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 4000
  });
}
if($('.js-intro-slides').length) {
  $('.js-intro-slides').slick({
    arrows: false,
    dots: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 4000
  });
}

function animationCounter() {
  $('.numbers-count').each(function () {
    $(this).css('opacity', 1).prop('Counter',0).animate({
        Counter: $(this).text()
    }, {
        duration: 1600,
        easing: 'swing',
        step: function (now) {
            $(this).text(Math.ceil(now));
        }
    });
  });
}
var counterTeaserL = $('.numbers-section');
var winHeight = $(window).height();
$( window ).resize(function() {
  winHeight = $(window).height();
});
if (counterTeaserL.length) {
    var firEvent = false,
        objectPosTop = $('.numbers-section').offset().top + 400;

        //when element shows at bottom
        var elementViewInBottom = objectPosTop - winHeight;
        var currentPosition = $(document).scrollTop();
        //when element position starting in viewport
      if (currentPosition > elementViewInBottom && firEvent === false) {
        firEvent = true;
        animationCounter();
      }
    $(window).on('scroll', function() {
        var currentPosition = $(document).scrollTop();
        //when element position starting in viewport
      if (currentPosition > elementViewInBottom && firEvent === false) {
        firEvent = true;
        animationCounter();
      }
    });
}

if($('.js-priority-slider').length) {
  $('.js-priority-slider').slick({
    arrows: false,
    dots: true
  });
}
$('.priority-item').hover(function() {
  $(this).find('p').fadeIn(300);
}, function() {
  $(this).find('p').fadeOut(300);
});

if($('.js-timeline-slider').length) {

  var cnt = $('.js-timeline-slider').children('div').length;

  $('.js-timeline-slider').slick({
    prevArrow: '<span class="slick-prev"><svg width="17" height="32" viewBox="0 0 17 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 0.999997L1 16L16 31" stroke="#661D57"/></svg></span>',
    nextArrow: '<span class="slick-next"><svg width="17" height="32" viewBox="0 0 17 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.00001 31L16 16L1.00001 0.999996" stroke="#661D57"/></svg></span>',
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $(".js-timeline-slider").slick('slickGoTo', cnt-2);
}

$('.js-header a').on('click', function(event) {

  // Make sure this.hash has a value before overriding default behavior
  if (this.hash !== "") {

    // Store hash
    var hash = this.hash;

    // Using jQuery's animate() method to add smooth page scroll
    // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
    $('html, body').animate({
      scrollTop: $(hash).offset().top
    }, 800, function() {

      // Add hash (#) to URL when done scrolling (default click behavior)
      window.location.hash = hash;
    });
    $('.js-header-nav-opener, .js-header-nav').removeClass('is-open');
    $('body').removeClass('is-nav-open');
    return false;
  } // End if
});

AOS.init({
  delay: 200,
  duration: 800,
  once: true,
  offset: 30
});

/*breaky.at("mobile-portrait", function() {
	console.log("AT 1. mobile-portrait");
});
breaky.above("mobile-portrait", function() {
	console.log("ABOVE 2. mobile-portrait");
});
breaky.below("desktop", function() {
  console.log("BELOW 3. desktop");
});
breaky.between("mobile-portrait", "tablet-portrait", function() {
	console.log("BETWEEN 4. mobile-portrait and tablet-portrait");
});*/

tablesWrap();
iframesWrap();

// TABLE (wysiwyg editor) responsive
function tablesWrap() {
	var contentTables = document.querySelectorAll(".o-content table"),
      i;

	for (i = 0; i < contentTables.length; ++i) {
		contentTables[i].classList.add("table");

    var contentTableWrap = document.createElement("div");

    contentTableWrap.classList.add("table-responsive");

		contentTables[i].parentNode.insertBefore(contentTableWrap, contentTables[i]);

		contentTableWrap.appendChild(contentTables[i]);
	}
}

// IFRAME youtube/google (wysiwyg editor) responsive
function iframesWrap() {
	var contentIframes = document.querySelectorAll(".o-content iframe"),
      i;

	for (i = 0; i < contentIframes.length; ++i) {
		contentIframes[i].removeAttribute("height");
		contentIframes[i].removeAttribute("width");

    var iframeWrap = document.createElement("div");
    iframeWrap.classList.add("ratio");
		iframeWrap.classList.add("ratio-16x9");

		contentIframes[i].parentNode.insertBefore(iframeWrap, contentIframes[i]);

		iframeWrap.appendChild(contentIframes[i]);
	}
}

(function( $ ) {
  $.fn.photoswipe = function(options){
      var galleries = [],
          _options = options;

      var init = function($this){
          galleries = [];
          $this.each(function(i, gallery){
              galleries.push({
                  id: i,
                  items: []
              });

              $(gallery).find('a').each(function(k, link) {
                  var $link = $(link),
                      size = $link.data('size').split('x');
                  if (size.length != 2){
                      throw SyntaxError("Missing data-size attribute.");
                  }
                  $link.data('gallery-id',i+1);
                  $link.data('photo-id', k);

                  var item = {
                      src: link.href,
                      msrc: link.children[0].getAttribute('src'),
                      w: parseInt(size[0],10),
                      h: parseInt(size[1],10),
                      title: $link.data('title'),
                      el: link
                  }

                  galleries[i].items.push(item);

              });

              $(gallery).on('click', 'a', function(e){
                  e.preventDefault();
                  var gid = $(this).data('gallery-id'),
                      pid = $(this).data('photo-id');
                  openGallery(gid,pid);
              });
          });
      }

      var parseHash = function() {
          var hash = window.location.hash.substring(1),
          params = {};

          if(hash.length < 5) {
              return params;
          }

          var vars = hash.split('&');
          for (var i = 0; i < vars.length; i++) {
              if(!vars[i]) {
                  continue;
              }
              var pair = vars[i].split('=');
              if(pair.length < 2) {
                  continue;
              }
              params[pair[0]] = pair[1];
          }

          if(params.gid) {
              params.gid = parseInt(params.gid, 10);
          }

          if(!params.hasOwnProperty('pid')) {
              return params;
          }
          params.pid = parseInt(params.pid, 10);
          return params;
      };

      var openGallery = function(gid,pid){
          var pswpElement = document.querySelectorAll('.pswp')[0],
              items = galleries[gid-1].items,
              options = {
                  index: pid,
                  galleryUID: gid,
                  getThumbBoundsFn: function(index) {
                      var thumbnail = items[index].el.children[0],
                          pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                          rect = thumbnail.getBoundingClientRect();

                      return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                  }
              };
          $.extend(options,_options);
          var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
          gallery.init();
      }

      // initialize
      init(this);

      // Parse URL and open gallery if it contains #&pid=3&gid=1
      var hashData = parseHash();
      if(hashData.pid > 0 && hashData.gid > 0) {
          openGallery(hashData.gid,hashData.pid);
      }

      return this;
  };
}( jQuery ));

if($('[data-pswp]').length) {
  $('body').append('<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true"><div class="pswp__bg"></div><div class="pswp__scroll-wrap"><div class="pswp__container"><div class="pswp__item"></div><div class="pswp__item"></div><div class="pswp__item"></div></div><div class="pswp__ui pswp__ui--hidden"><div class="pswp__top-bar"><div class="pswp__counter"></div><button class="pswp__button pswp__button--close" title="Close (Esc)"></button><button class="pswp__button pswp__button--share" title="Share"></button><button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button><button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button><div class="pswp__preloader"><div class="pswp__preloader__icn"><div class="pswp__preloader__cut"><div class="pswp__preloader__donut"></div></div></div></div></div><div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"><div class="pswp__share-tooltip"></div></div><button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"> </button><button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"> </button><div class="pswp__caption"><div class="pswp__caption__center"></div></div></div></div></div>');
  $('[data-pswp]').photoswipe({
    bgOpacity: 0.8,
    loop: true
  });
}

/* Trick with viewport height when need 100vh at mobile. */
var vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));

window.addEventListener('resize', function () {
	var vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
});

})( jQuery );

document.addEventListener('DOMContentLoaded', () => naja.initialize());
